import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export type Crumb = { label: string; to?: string; params?: Record<string, string> };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Konum" className="text-[12px] text-ink/70 sm:text-[13px]">
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        <li><Link to="/" className="hover:text-ink">Ana sayfa</Link></li>
        {items.map((c, i) => (
          <li key={i} className="flex min-w-0 items-center gap-1.5">
            <ChevronRight aria-hidden className="size-3 shrink-0 text-ink/40" />
            {c.to && i < items.length - 1 ? (
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              <Link to={c.to as any} params={c.params as any} className="hover:text-ink">{c.label}</Link>
            ) : (
              <span aria-current={i === items.length - 1 ? "page" : undefined} className="min-w-0 truncate text-ink/85">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
